'use strict';

import React from 'react';

import { OnSchedUtils } from '../../utils';

import Title            from '../../components/Title/Title';
import List             from '../../components/List/List';


const Appointments = element => 
<>
  <Title
    element={element}
    title={OnSchedUtils.Internationalize(element, 'consumer_appointments_title')}
  />
  
  <List 
    image="imageUrl"
    element={element}
    event="clickAppointment" 
    properties={
      element.options.properties
      ? element.options.properties
      : [ 
      OnSchedUtils.Internationalize(element, 'consumer_appointment_detail'), 
      OnSchedUtils.Internationalize(element, 'consumer_appointment_duration')
    ]} 
  />
</>

export default Appointments
